/**
 * Strip timestamp from filename (e.g., "file-1234567890.xml" -> "file.xml")
 * @param filename - The filename with potential timestamp
 * @returns The filename without timestamp
 */
export const stripTimestamp = (filename: string): string => {
  // Match pattern: basename-timestamp.extension
  const match = filename.match(/^(.+?)-\d+(\.[^.]+)$/);
  if (match) {
    return match[1] + match[2];
  }
  return filename;
};
